export const SWOrange = "#FFB906";
export const worldCupGrey = "#24274A";
